/**
 * Decodes base64 PDF bytes (the shape oRPC download endpoints return, since
 * oRPC is JSON-based) and hands them to the browser as a file download.
 */
export function downloadBase64Pdf(base64: string, filename: string): void {
  const byteString = atob(base64);
  const bytes = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    bytes[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
